export default __webpack_public_path__ + "static/media/rbac_auth.e13302f7.svg";